import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, OnInit, Input } from '@angular/core';
import * as ApexCharts from 'apexcharts';
import { CommonService } from 'src/app/services/common/common.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-advisor-profile',
  templateUrl: './advisor-profile.component.html',
  styleUrls: ['./advisor-profile.component.scss'],
})
export class AdvisorProfileComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

  @Input() advisor_data: any;

  selected_tab: any = 'Basic Information';

  selected_employment_tab: any = 'Summary';

  base_url: any = environment.apiEndpoint + '/';

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    // this.getGraphData();
  }
  graphSlideConfig = {
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
  };
  selected_period: any = 'current month';
  advisor_performance_data: any;
  graph_loaded: boolean = false;
  getGraphData() {
    this.graph_loaded = false;
    this.commonService
      .getData(
        '/advisorpastperformance/?id=' +
          this.advisor_data.id +
          '&duration=' +
          this.selected_period,
      )
      .subscribe(
        (res: any) => {
          this.advisor_performance_data = res['data'];
          this.graph_loaded = true;
          setTimeout(() => {
            this.createAdvisorPerformanceGraph();
          }, 200);
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  abbreviateNumber(value) {
    let fixed = 1;
    let num = value;
    if (num === null) {
      return null;
    }
    if (num === 0) {
      return '0';
    }
    fixed = !fixed || fixed < 0 ? 0 : fixed;
    var b = num.toPrecision(2).split('e'),
      k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
      c =
        k < 1
          ? num.toFixed(0 + fixed)
          : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
      d = c < 0 ? c : Math.abs(c),
      e = d + ['', 'K', 'M', 'B', 'T'][k];
    return e;

    // value = Math.round(value);
    // let new_value = value;
    // if (value >= 1000) {
    //     const suffixes = ["", "K", "M", "B","T"];
    //     const suffixNum = Math.floor( (""+value).length/3 );
    //     let shortValue: any = '';
    //     for (var precision = 2; precision >= 1; precision--) {
    //         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
    //         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
    //         if (dotLessShortValue.length <= 2) { break; }
    //     }
    //     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
    //     new_value = shortValue+suffixes[suffixNum];
    // }
    // return new_value;
  }

  createAdvisorPerformanceGraph() {
    var options = {
      series: [
        {
          name: 'AUM',
          data: this.advisor_performance_data['performance_aum']['y-axis'],
        },
      ],
      chart: {
        height: 350,
        type: 'area',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'text',
        categories: this.advisor_performance_data['performance_aum']['x-axis'],
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#advisor-performance-graph'),
      options,
    );
    chart.render();
  }
}
